import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject, input } from '@angular/core';
import { ButtonDirective } from '../primitives/button/button.directive';

@Component({
  selector: 'cui-dialog-close-button',
  standalone: true,
  imports: [ButtonDirective],
  template: `
    <button
      cuiButton
      square
      variant="plain"
      type="button"
      [attr.aria-label]="label()"
      (click)="close()">
      <span class="material-symbols-outlined" aria-hidden="true">close</span>
    </button>
  `,
})
export class DialogCloseButtonComponent {
  readonly label = input('Close dialog');

  private readonly dialogRef = inject<DialogRef<unknown>>(DialogRef);

  close(): void {
    this.dialogRef.close();
  }
}
